.prompt {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    z-index: var(--tempest-z-toast, 1000);
    display: flex;
    align-items: center;
    gap: var(--tempest-space-3);
    max-width: calc(100vw - 2 * var(--tempest-space-4));
    padding: var(--tempest-space-3) var(--tempest-space-4);
    border-radius: var(--tempest-radius-md);
    background: var(--tempest-info-bg);
    color: var(--tempest-info-fg);
    border: 1px solid var(--tempest-info-border);
    box-shadow: var(--tempest-shadow-lg);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-sm);
    line-height: var(--tempest-leading-snug);
}

.top {
    top: max(var(--tempest-space-4), env(safe-area-inset-top));
}

.bottom {
    bottom: max(var(--tempest-space-4), env(safe-area-inset-bottom));
}

.icon {
    flex: 0 0 auto;
}

.message {
    flex: 1 1 auto;
    min-width: 0;
}

.action {
    flex: 0 0 auto;
    padding: var(--tempest-space-1) var(--tempest-space-3);
    border: 1px solid currentColor;
    border-radius: var(--tempest-radius-sm);
    background: transparent;
    color: currentColor;
    font-family: inherit;
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
    cursor: pointer;
}

.action:hover {
    background: color-mix(in srgb, currentColor 12%, transparent);
}

.dismiss {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    border: 0;
    border-radius: var(--tempest-radius-sm);
    background: none;
    color: currentColor;
    cursor: pointer;
}

.dismiss:hover {
    background: color-mix(in srgb, currentColor 12%, transparent);
}
